import { fetchFromNewApi } from '~/services/Http';
import { APIs } from '~/services/Http/internalAPIs';

export const formsRehireSubmit = async (formId: string, data: unknown) => {
  return fetchFromNewApi(APIs.forms.formRehireEmpSubmission(formId), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then((r) => r.json())
    .then((data) => data)
    .catch((e) => {
      console.log('error', e);
      throw e;
    });
};
